var _path, _circle, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLeft(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 50,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 14a3 3 0 013-3h7a1 1 0 110 2h-7a1 1 0 00-1 1v22a1 1 0 001 1h7a1 1 0 110 2h-7a3 3 0 01-3-3V14z",
    fill: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.302,
    cy: 38,
    r: 2.698,
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.41 13.414l-3.536 3.536a1 1 0 01-1.414-1.414l2.121-2.122a2 2 0 000-2.828L18.46 8.464a1 1 0 011.414-1.414l3.535 3.536a2 2 0 010 2.828z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iNTAiIHZpZXdCb3g9IjAgMCAyNCA1MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExIDE0QzExIDEyLjM0MzEgMTIuMzQzMSAxMSAxNCAxMUgyMUMyMS41NTIzIDExIDIyIDExLjQ0NzcgMjIgMTJWMTJDMjIgMTIuNTUyMyAyMS41NTIzIDEzIDIxIDEzSDE0QzEzLjQ0NzcgMTMgMTMgMTMuNDQ3NyAxMyAxNFYzNkMxMyAzNi41NTIzIDEzLjQ0NzcgMzcgMTQgMzdIMjFDMjEuNTUyMyAzNyAyMiAzNy40NDc3IDIyIDM4VjM4QzIyIDM4LjU1MjMgMjEuNTUyMyAzOSAyMSAzOUgxNEMxMi4zNDMxIDM5IDExIDM3LjY1NjkgMTEgMzZWMTRaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPGNpcmNsZSBjeD0iMjEuMzAxOCIgY3k9IjM4IiByPSIyLjY5ODE5IiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMy40MDk1IDEzLjQxNDJMMTkuODc0IDE2Ljk0OTdDMTkuNDgzNCAxNy4zNDAzIDE4Ljg1MDMgMTcuMzQwMyAxOC40NTk3IDE2Ljk0OTdWMTYuOTQ5N0MxOC4wNjkyIDE2LjU1OTIgMTguMDY5MiAxNS45MjYxIDE4LjQ1OTcgMTUuNTM1NUwyMC41ODExIDEzLjQxNDJDMjEuMzYyMSAxMi42MzMyIDIxLjM2MjEgMTEuMzY2OCAyMC41ODExIDEwLjU4NThMMTguNDU5NyA4LjQ2NDQ3QzE4LjA2OTIgOC4wNzM5NCAxOC4wNjkyIDcuNDQwNzggMTguNDU5NyA3LjA1MDI1VjcuMDUwMjVDMTguODUwMyA2LjY1OTczIDE5LjQ4MzQgNi42NTk3MyAxOS44NzQgNy4wNTAyNUwyMy40MDk1IDEwLjU4NThWMTAuNTg1OEMyNC4xOTA1IDExLjM2NjggMjQuMTkwNSAxMi42MzMyIDIzLjQwOTUgMTMuNDE0MlYxMy40MTQyWiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };